import React from 'react';
import { ApplicationItem } from './ApplicationItem';
import { cn } from '@workspace/lib';
import { ApplicationListProps } from '../application.types';

export function ApplicationList({ items }: ApplicationListProps) {
  const gridClass = cn('grid w-full gap-6', 'grid-cols-1 md:grid-cols-3');

  return (
    <div className="mx-auto w-full max-w-300">
      <div className={gridClass}>
        {items?.map((item, key: number) => (
          <ApplicationItem key={key} item={item} className="h-full w-full" />
        ))}
      </div>
    </div>
  );
}
